import * as React from 'react';
export const IcDancing = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7.71.29a.999.999 0 00-1.42 0l-2 2a1 1 0 01-1.15.19l-1.82-.91a3 3 0 00-2.68 0l-1.82.91a1 1 0 01-1.15-.19l-2-2a1 1 0 00-1.38 1.42l2 2a3 3 0 003.47.56L11 8.62v3.81l-3.06 1.84A4 4 0 006 17.7V21a1 1 0 102 0v-3.3A2 2 0 019 16l2.51-1.5 2.58 6.87A1.002 1.002 0 0015 22a1 1 0 00.684-.265 1.002 1.002 0 00.256-1.085L13 12.82v-4.2l1.26.63c.42.208.882.317 1.35.32a3 3 0 002.12-.88l2-2a1 1 0 00-.02-1.4z'
      fill='currentColor'
    />
  </svg>
);
